export default "__VITE_PUBLIC_ASSET__321f3687__"